<!-- 模板 -->
<template>
  <div class="mpage" v-cloak>
    <h3>扫码关注公众号</h3>
    <div>
      <img :src="document.domain+document.ewm" alt="">
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: "wechart-qrcode",
  components: {},
  props: {},
  data() {
    return {
      document: {
        siteName: "", //系统名称
        domain: "", //url
        companyAddr: "", //公司地址
        companyTel: "", //公司电话
        hotline: "", //服务热线
        ewm: "", //二维码地址
        file: "",
      },
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.$toast.loading();
    this.getInit();
  },
  methods: {
    getInit() {
      let _this = this;
      let data = {
        group: "basic",
      };
      _this.$post("/api/sys_config", data, data).then((res) => {
        console.log(res.data, "关于我们");
        this.$toast.clear();
        if (res.data && res.data.code == 0) {
          this.document = res.data.data;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    formatRichText(html) {
      /*
       * 处理富文本里的图片宽度自适应
       * 1.去掉img标签里的style、width、height属性
       * 2.img标签添加style属性：max-width:100%;height:auto
       * 3.修改所有style里的width属性为max-width:100%
       * 4.去掉<br/>标签
       * @param html
       * @returns {void|string|*}
       */
      let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      // newContent = newContent.replace(/<br[^>]*\/>/gi, '');
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:inline-block;"'
      );

      //去除table的宽度
      newContent = newContent.replace(
        /<table[^>]*>/gi,
        function (match, capture) {
          return match.replace(/width=\"(.*)\"/gi, "");
        }
      );

      //去除text-indent
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/text-indent:[^;]+;/gi, "text-indent:0")
            .replace(/text-indent:[^;]+;/gi, "text-indent:0");
          return match;
        }
      );
      return newContent;
    },
  },
};
</script>

<style lang="scss" scoped>
.mpage {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;

  h3 {
    margin-bottom: 30px;
  }
}
</style>
